import { ConfirmationModal } from 'components/modals/ConfirmationModal';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useState } from 'react';

export function useDeactivateAccount(props) {
    const {
        selectedBillingSetup,
        deactivateAccount_requesting,
        isAccountRecordUpdatedSuccessfully,
    } = props;

    const [isModalVisible_deactivateBillingSetup, setIsModalVisible_deactivateBillingSetup] = useState(false);

    function validateOnDeactivate(selectedAccounts) {
        if (func_validation.isArrayNotEmpty(selectedAccounts)) {
            setIsModalVisible_deactivateBillingSetup(true);

            if (func_validation.isFunction(props.setSelectedBillingSetup)) 
                props.setSelectedBillingSetup(selectedAccounts);
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 row.",
            });
        }
    }
    function handleAccount_deactivate() {
        if (func_validation.isArrayNotEmpty(selectedBillingSetup)) {
            selectedBillingSetup.map((billingSetup) => {
                let billingSetupId = func_validation.getObjectPropertyValue(billingSetup, "Id");

                if (func_validation.isNumberValid(billingSetupId) &&
                    props.deactivateAccount)
                    props.deactivateAccount(billingSetupId);
            });
        }
    }

    let deactivateAccountModal = (
        <ConfirmationModal
            className={"recursiveBillingSetup-deactivateAccount"}
            headerClassName={"recursiveBillingSetup-deactivateAccount-header"}
            description={"The selected billing setup(s) will be deactivated."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible_deactivateBillingSetup}
            updateParentState={setIsModalVisible_deactivateBillingSetup}
            handleOnConfirm={handleAccount_deactivate}
            isActionLoading={deactivateAccount_requesting}
            isConfirmSuccessful={isAccountRecordUpdatedSuccessfully}
        />
    );
    
    return {
        validateOnDeactivate,
        handleAccount_deactivate,
        deactivateAccountModal
    }
}